import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import { LabelField } from "../ui/label";

interface SelectFieldProps<T extends string[]> {
	readonly value: string;
	readonly onChange: (value: T[number]) => void;
	readonly errors?: string[];
	readonly options: Record<T[number], string>;
	readonly label?: string;
}
export function SelectInput<T extends string[]>(props: SelectFieldProps<T>) {
	const optionsKeys: T = Object.keys(props.options) as T;
	const errors = props.errors ?? [];

	const Input = (
		<Select value={props.value} onValueChange={props.onChange}>
			<SelectTrigger>
				<SelectValue placeholder="Selecciona una opción" />
			</SelectTrigger>
			<SelectContent>
				{optionsKeys.map((option: T[number]) => (
					<SelectItem key={option} value={option}>
						{props.options[option]}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);

	return (
		<div>
			{props.label ? <LabelField label={props.label}>{Input}</LabelField> : Input}

			{errors.map((error) => (
				<div key={error} style={{ color: "red" }}>
					{error}
				</div>
			))}
		</div>
	);
}